import { useQuery } from '@tanstack/react-query';
import { listWarehouses } from './api';

/**
 * The warehouses this user can reach, inactive ones included.
 *
 * One key shared by every consumer — the warehouses screen, the locations
 * warehouse filter, and the location form's warehouse picker — so they don't
 * each fetch the same list under a different key. Callers narrow to active rows
 * themselves; the screen that manages warehouses needs the inactive ones.
 *
 * "The tenant's warehouses" until tenant script 058, when the endpoint began narrowing itself to
 * the caller. Nothing changes for anyone unscoped, which every tenant administrator is; a
 * warehouse-scoped user now sees only their own here, which is the point.
 *
 * One consequence worth knowing about. The item form's warehouse grid is built from this list, so
 * a scoped user editing an item that is ALSO stocked in a warehouse they cannot reach sees no row
 * for it. The assignment is not lost — the form submits the ids it loaded from the item, not the
 * rows it drew — but there is no way for them to remove it either, which is correct: it is not
 * theirs to remove.
 */
export const WAREHOUSES_KEY = ['warehouses', 'all'] as const;

export function useWarehouses() {
  return useQuery({
    queryKey: WAREHOUSES_KEY,
    queryFn: ({ signal }) => listWarehouses(true, signal),
  });
}
